import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom';
import LoginPage from './pages/login';
import { ProfileView } from './pages/profile';
import PrincipalMenu from './pages/schoolsDinam';
import GroupPage from './pages/beneficiariesGroup';
import CopAdvisorEvidences from './pages/copAdvisorEvidences';
import MeetingsList from './pages/meetingsList';
import ResultsLog from './pages/resultsLog';
import SingleMeeting from './pages/singleMeeting';
import Characterization from './pages/characterization';
import AdminSchoolMenu from './pages/adminSchoolsMenu';
import AdminSchools from './pages/adminSchools';
import UserListAdmin from './pages/usersListAdmin';
import RootLayout from './layouts/rootLayout';
import AdminMenu from './pages/adminMenu';
import AdminEvidenceWorkspace from './pages/adminEvidenceWorkspace';
import UsersRolAdmin from './pages/usersRolAdmin';
import CharacterizationAdmin from './pages/characterizationAdmin';
import BeneficiariesAdmin from './pages/beneficiariesAdmin';
import { UserNameProvider } from './contexts/userName';
import { LoaderProvider } from './contexts/loader/loader';
import Assistence from './pages/asistenceAdmin';
import SingleAssistence from './pages/singleAssistence';
import ErrorComponent from './pages/errorComponent';
import RegisterSchoolsDinam from './pages/registerSchoolsDinam';
import ExplorationEvidence from './pages/explorationEvidence';
import SocializationEvidence from './pages/socializationEvidence';
import EvidencesAdmin from './pages/evidencesAdmin';
import AdminProgressDashboard from './pages/adminProgressDashboard';
import AdminCharacterizedAnalysis from './pages/adminCharacterizedAnalysis';
import AdminCoverageAnalysis from './pages/adminCoverageAnalysis';
import CalendarPage from './pages/calendar';
import { PublicOnly, RequireAuth } from './routes/routeGuards';
import ExternalAttendanceForm from './pages/externalAttendance';
import OfficialAttendanceReport from './pages/officialAttendanceReport';
import PublicMeetingAttendance from './pages/publicMeetingAttendance';
import SatisfactionResponses from './pages/satisfactionResponses';
import TerritoryVisitsMenu from './pages/territoryVisitsMenu';
import TerritoryVisitForm from './pages/territoryVisitForm';
import TerritoryVisitsList from './pages/territoryVisitsList';
import ReviewerDashboard from './pages/reviewerDashboard';
import ReviewerEvidenceBrowser from './pages/reviewerEvidenceBrowser';
import ReviewerIncidenceEvidences from './pages/reviewerIncidenceEvidences';
import ReviewerTrafficLight from './pages/reviewerTrafficLight';
import ReviewerEvidenceHistory from './pages/reviewerEvidenceHistory';
import ReviewerCharacterizations from './pages/reviewerCharacterizations';
import SuperadminDashboard from './pages/superadminDashboard';
import SuperadminAttendanceWindows from './pages/superadminAttendanceWindows';
import SuperadminIncidenceEvidences from './pages/superadminIncidenceEvidences';
import SuperadminResultsLogs from './pages/superadminResultsLogs';
import IncidenceActionForm from './pages/incidenceActionForm';
import IncidenceActions from './pages/incidenceActions';
import LogisticsDashboard from './pages/logisticsDashboard';
import Requirements from './pages/requirements';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={<RootLayout />}>
        <Route element={<PublicOnly />}>
          <Route path='/login' element={<LoginPage />} />
        </Route>

        <Route path='/registro-externo' element={<ExternalAttendanceForm />} />
        <Route path='/registro-jornada' element={<Characterization />} />
        <Route path='/firma-encuentro' element={<PublicMeetingAttendance />} />

        <Route element={<RequireAuth />}>
          <Route index element={<ProfileView />} />
          <Route path='/superadmin' element={<SuperadminDashboard />} />
          <Route path='/logistica' element={<LogisticsDashboard />} />
          <Route path='/requerimientos' element={<Requirements />} />
          <Route path='/superadmin/plazos-firmas' element={<SuperadminAttendanceWindows />} />
          <Route path='/superadmin/evidencias-incidencia' element={<SuperadminIncidenceEvidences />} />
          <Route path='/superadmin/bitacoras-cierre' element={<SuperadminResultsLogs />} />
          <Route
            path='/superadmin/usuarios'
            element={<UsersRolAdmin />}
          />
          <Route path='/revisor' element={<ReviewerDashboard />} />
          <Route
            path='/revisor/evidencias'
            element={<ReviewerEvidenceBrowser />}
          />
          <Route
            path='/revisor/evidencias-incidencia'
            element={<ReviewerIncidenceEvidences />}
          />
          <Route
            path='/revisor/asistencia'
            element={<OfficialAttendanceReport />}
          />
          <Route
            path='/revisor/semaforo'
            element={<ReviewerTrafficLight />}
          />
          <Route
            path='/revisor/historial'
            element={<ReviewerEvidenceHistory />}
          />
          <Route
            path='/revisor/calendario'
            element={<CalendarPage />}
          />
          <Route
            path='/revisor/caracterizaciones'
            element={<ReviewerCharacterizations />}
          />
          <Route
            path='/revisor/caracterizaciones/ver-beneficiario'
            element={<BeneficiariesAdmin />}
          />
          <Route path='/calendario' element={<CalendarPage />} />
          <Route path='/semaforo' element={<ReviewerTrafficLight />} />
          <Route path='/escuelas' element={<PrincipalMenu />} />
          <Route path='/acciones-incidencia' element={<IncidenceActions />} />
          <Route path='/acciones-incidencia/nueva' element={<IncidenceActionForm />} />
          <Route path='/acciones-incidencia/:actionId' element={<IncidenceActionForm />} />
          <Route path='/registrarEscuelas' element={<RegisterSchoolsDinam />} />
          <Route path='/escuelas/grupo' element={<GroupPage />} />
          <Route path='/escuelas/asesoria/:schoolParam' element={<GroupPage />} />
          <Route
            path='/escuelas/asesoria/:schoolParam/evidencias'
            element={<CopAdvisorEvidences />}
          />
          <Route path='/exploracion/:schoolId' element={<ExplorationEvidence />} />
          <Route path='/socializacion/:schoolId' element={<SocializationEvidence />} />
          <Route
            path='/escuelas/grupo/:groupParam/school/:schoolParam'
            element={<GroupPage />}
          />
          <Route
            path='/escuelas/grupo/lista_de_encuentros'
            element={<MeetingsList />}
          />
          <Route
            path='/escuelas/grupo/lista_de_encuentros/bitacora-de-resultados'
            element={<ResultsLog />}
          />
          <Route
            path='/escuelas/grupo/lista_de_encuentros/encuentro'
            element={<SingleMeeting />}
          />
          <Route
            path='/escuelas/grupo/lista_de_encuentros/satisfaccion'
            element={<SatisfactionResponses />}
          />
          <Route path='/caracterizacion' element={<Characterization />} />
          <Route
            path='/caracterizacion-jornada/school/:schoolParam/group/:groupParam'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion-jornada/control-social/group/:activityGroupParam'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion/:paramValue'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion/edit/:bid'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion/:paramValue/school/:schoolParam'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion/:paramValue/school/:schoolParam/group/:groupParam'
            element={<Characterization />}
          />
          <Route
            path='/caracterizacion/:paramValue/control-social/group/:activityGroupParam'
            element={<Characterization />}
          />
          <Route path='/administrador' element={<AdminSchoolMenu />} />
          <Route
            path='/administrador/avances'
            element={<AdminProgressDashboard />}
          />
          <Route
            path='/administrador/avances/analisis-caracterizados'
            element={<AdminCharacterizedAnalysis />}
          />
          <Route
            path='/administrador/avances/analisis-cobertura'
            element={<AdminCoverageAnalysis />}
          />
          <Route path='/administrador/menu' element={<AdminMenu />} />
          <Route
            path='/administrador/menu/montar-evidencias'
            element={<AdminEvidenceWorkspace />}
          />
          <Route
            path='/administrador/menu/calendario'
            element={<CalendarPage />}
          />
          <Route
            path='/administrador/semaforo'
            element={<ReviewerTrafficLight />}
          />

          <Route path='/administrador/menu/escuelas' element={<AdminSchools />} />
          <Route
            path='/administrador/menu/evidencias'
            element={<EvidencesAdmin />}
          />
          <Route
            path='/administrador/visitas-territorio'
            element={<TerritoryVisitsMenu />}
          />
          <Route
            path='/administrador/visitas-territorio/visualizar'
            element={<TerritoryVisitsList />}
          />
          <Route
            path='/administrador/visitas-territorio/registrar'
            element={<TerritoryVisitForm />}
          />
          <Route
            path='/administrador/menu/caracterizacion'
            element={<CharacterizationAdmin />}
          />
          <Route
            path='/administrador/menu/asistencias'
            element={<Assistence />}
          />
          <Route
            path='/administrador/menu/asistencias/encuentro'
            element={<SingleAssistence />}
          />
          <Route
            path='/generar-listado-asistencia'
            element={<OfficialAttendanceReport />}
          />
          <Route
            path='/administrador/menu/escuelas/beneficiarios_inscritos'
            element={<UserListAdmin />}
          />
          <Route
            path='/administrador/menu/caracterizacion/ver_beneficiarios'
            element={<BeneficiariesAdmin />}
          />
        </Route>
        <Route path='*' element={<ErrorComponent />} />
      </Route>
    )
  );

  return (
    <UserNameProvider>
      <LoaderProvider>
        <RouterProvider router={router} />
      </LoaderProvider>
    </UserNameProvider>
  );
}

export default App;
